// extracted by mini-css-extract-plugin
export var notificationHost = "_dw-0";